// react
import { useDispatch } from 'react-redux';

// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import {
  createFileRoute,
  useNavigate,
  useParams,
} from '@tanstack/react-router';

// material ui
import { Container } from '@mui/material';

// shared components
import PageHeader from '@/components/layout/PageHeader';

// components
import CreateGatewayForm from '@/features/gateways/forms/CreateGatewayForm';
import { useAlertProvider } from '@/hooks/useAlertProvider';
import { showSnackbar } from '@/redux/snackbarSlice';

export const Route = createFileRoute('/$accountId/_user/gateways/create')({
  component: RouteComponent,
  staticData: { crumb: 'units-gateways-sensors:common.create' },
});

function RouteComponent() {
  const { t } = useTranslation('units-gateways-sensors');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { accountId } = useParams({ strict: false });

  useAlertProvider({
    enabled: !Number(accountId),
    severity: 'error',
    message: t('gateways.invalidAccountId', {
      ns: 'units-gateways-sensors',
    }),
  });

  const handleSuccess = (createdGateway) => {
    navigate({ to: `/$accountId/gateways` });
    dispatch(
      showSnackbar({
        message: t('gateways.gatewayRegisteredSuccess', {
          name: createdGateway.Name,
          ns: 'units-gateways-sensors',
        }),
        severity: 'success',
      }),
    );
  };

  const handleCancel = () => {
    navigate({ to: `/$accountId/gateways` });
  };

  if (!Number(accountId)) {
    throw new Error(
      t('gateways.invalidAccountId', { ns: 'units-gateways-sensors' }),
    );
  }

  return (
    <Container
      maxWidth="md"
      sx={{ py: 2 }}
      data-testid="gateway-register-container"
    >
      <PageHeader title={t('gateways.registerGateway')} disableArrow />
      <CreateGatewayForm
        accountId={Number(accountId)}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Container>
  );
}
